import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import useLangStore from '../store/langStore';

// Importa tus archivos de traducción
import translationES from '../translations/es/translation.json';
import translationCA from '../translations/ca/translation.json';

// Las traducciones de cada idioma
const resources = {
  es_ES: {
    translation: translationES,
  },
  ca_ES: {
    translation: translationCA,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: resources[document.cookie.split(';').find((cookie) => cookie.includes('locale'))?.split('=')[1]] ? document.cookie.split(';').find((cookie) => cookie.includes('locale'))?.split('=')[1] : 'ca_ES',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

useLangStore.subscribe(
  (state) => {
    i18n.changeLanguage(state.lang);
    Locale.postMessage(state.lang);
  }
);

export default i18n;
